/**
 * Flag to turn on/off consent manger.
 *
 * https://app.optimizely.com/v2/projects/15340850549/features/22011580202#modal
 */
export const MARTECH_ENABLE_CONSENT_MANGER = 'martech_enable_consent_manger'

export const ENABLE_UTM_BACKUP_FEATURE = 'utm_backup_enabled'
